import BaseModelAPI from '../BaseModelAPI';

export default class OutgoingCheckDetail extends BaseModelAPI {
	static entity = 'outgoingcheckdetail';
	static entityName = 'outgoingcheckdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.outgoingCheckId = '';
			this.outgoingCheck = {};
			this.deliveryInstructionDetailId = '';
			this.deliveryInstructionDetail = {};
			this.partId = '';
			this.part = {};
			this.deliveryQty = 0;
			this.isCompleted = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}